import { render } from "./SelecionarFormacaoPreco.vue?vue&type=template&id=f63a503a&scoped=true&ts=true"
import script from "./SelecionarFormacaoPreco.vue?vue&type=script&lang=ts"
export * from "./SelecionarFormacaoPreco.vue?vue&type=script&lang=ts"

import "./SelecionarFormacaoPreco.vue?vue&type=style&index=0&id=f63a503a&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f63a503a"]])

export default __exports__